(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumin-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ntb-deferred-video')) {
    customElements.define('ntb-deferred-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video || this.visibilityHandler) return;
        this.visibilityHandler = () => {
          if (document.hidden) this.video.pause();
        };
        document.addEventListener('visibilitychange', this.visibilityHandler);
        if ('IntersectionObserver' in window) {
          this.videoObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) entry.target.pause();
            });
          });
          this.videoObserver.observe(this.video);
        }
      }
      disconnectedCallback() {
        this.video?.pause();
        this.videoObserver?.disconnect();
        document.removeEventListener('visibilitychange', this.visibilityHandler);
        this.visibilityHandler = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ntb-customer-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ntb-customer-gallery')) {
    customElements.define('ntb-customer-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.cards = [...this.querySelectorAll('.ntb-cg__card')];
        this.initial = Number(this.dataset.initial) || this.cards.length;
        this.limit = this.initial;
        this.filter = 'all';
        this.dialog = this.querySelector('dialog');
        this.querySelector('.ntb-cg__filters')?.removeAttribute('hidden');
        this.addEventListener('click', (event) => {
          const filter = event.target.closest('[data-filter]');
          const opener = event.target.closest('[data-open]');
          if (filter) {
            this.filter = filter.dataset.filter;
            this.limit = this.initial;
            this.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
            this.render();
          }
          if (event.target.closest('[data-more]')) {
            const firstNew = this.filteredCards[this.limit];
            this.limit += this.initial;
            this.render();
            firstNew?.querySelector('[data-open]')?.focus({ preventScroll: true });
          }
          if (opener) {
            this.opener = opener;
            this.index = this.filteredCards.indexOf(opener.closest('.ntb-cg__card'));
            this.showPhoto();
            this.dialog.showModal();
          }
          if (event.target.closest('[data-close]') || event.target === this.dialog) this.dialog.close();
          if (event.target.closest('[data-prev]')) this.move(-1);
          if (event.target.closest('[data-next]')) this.move(1);
        });
        this.dialog.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.move(event.key === 'ArrowLeft' ? -1 : 1);
          }
        });
        this.dialog.addEventListener('close', () => this.opener?.focus({ preventScroll: true }));
        this.render();
      }
      render() {
        this.filteredCards = this.cards.filter(card => this.filter === 'all' || card.dataset.category === this.filter);
        this.cards.forEach(card => { card.hidden = !this.filteredCards.includes(card) || this.filteredCards.indexOf(card) >= this.limit; });
        this.querySelector('.ntb-cg__more').hidden = this.limit >= this.filteredCards.length;
        const status = this.querySelector('[data-status]');
        if (this.querySelector('[data-filter]')) status.textContent = status.dataset.format.replace('[shown]', Math.min(this.limit, this.filteredCards.length)).replace('[total]', this.filteredCards.length);
      }
      move(step) {
        this.index = (this.index + step + this.filteredCards.length) % this.filteredCards.length;
        this.showPhoto();
      }
      showPhoto() {
        const card = this.filteredCards[this.index];
        const crop = card.querySelector('.ntb-cg__crop').cloneNode(true);
        crop.querySelector('.ntb-cg__zoom')?.remove();
        const image = crop.querySelector('img');
        const url = new URL(image.currentSrc || image.src, window.location.href);
        url.searchParams.set('width', '1600');
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.loading = 'eager';
        image.src = url.href;
        this.querySelector('[data-dialog-photo]').replaceChildren(crop);
        this.querySelector('[data-dialog-caption]').textContent = card.querySelector('figcaption').textContent;
        this.querySelector('[data-dialog-count]').textContent = `${this.index + 1} / ${this.filteredCards.length}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video-new"] && !Shopify.designMode) return;
  try {
    
class KsShoppableVideos extends HTMLElement {
  constructor () {
    super()
/*
    if (!document.querySelector('#swiper-stylesheet')) {
      const stylesheet = document.createElement('link')
      stylesheet.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css')
      stylesheet.setAttribute('rel', 'stylesheet')
      stylesheet.setAttribute('id', 'swiper-stylesheet')
      stylesheet.setAttribute('integrity', 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow=')
      stylesheet.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(stylesheet)
    }

    if (!document.querySelector('#swiper-script')) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js')
      script.setAttribute('id', 'swiper-script')
      script.setAttribute('integrity', 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0=')
      script.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(script)
    }
*/
    setTimeout(() => {
      const slider = new window.Swiper(this.querySelector('.swiper'), this.splideOptions())

      slider.on('slideChange', () => {
        this.querySelector('.swiper').classList.add('swiper-is-changing')
        this.onSlideChange()
      })

      slider.on('slideChangeTransitionEnd', () => {
        this.querySelector('.swiper').classList.remove('swiper-is-changing')
      })
    }, 500)
    
    this.querySelectorAll('.lumin-shoppable-videos-btn-play').forEach(btn => {
      btn.addEventListener('click', () => {
        const video = btn.closest('.lumin-shoppable-videos-video-wrapper').querySelector('video')
        this.onVideoPlay(video)
      })
    })

    this.querySelectorAll('video').forEach(video => {
      video.addEventListener('click', () => {
        this.onVideoPlay(video)
      })
    })

  }

  connectedCallback () {
    if (this.videoVisibilityHandler) return
    this.videoVisibilityHandler = () => {
      if (document.hidden) this.onSlideChange()
    }
    document.addEventListener('visibilitychange', this.videoVisibilityHandler)
    if (!('IntersectionObserver' in window)) return
    this.lazyVideosObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target
        const card = video.closest('.lumin-shoppable-videos-card')
        if (!entry.isIntersecting) {
          video.pause()
          video.muted = true
          card?.setAttribute('data-is-playing', 'false')
          return
        }
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
        const saveData = navigator.connection?.saveData
        if (video.dataset.autoplay === 'true' && !reduceMotion && !saveData && !document.hidden) {
          video.muted = true
          const playback = video.play()
          playback?.catch(() => {})
        }
      })
    })
    this.querySelectorAll('video').forEach((video) => this.lazyVideosObserver.observe(video))
  }

  disconnectedCallback () {
    this.lazyVideosObserver?.disconnect()
    document.removeEventListener('visibilitychange', this.videoVisibilityHandler)
    this.videoVisibilityHandler = null
    this.onSlideChange()
  }

  splideOptions () {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    /** @type {SwiperOptions} */
    const options = {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true
        // hide: true
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
        : undefined,
      watchSlidesProgress: true, 
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
    }
    return options
  }

  onSlideChange () {
    this.querySelectorAll('.lumin-shoppable-videos-card').forEach(elem => {
      elem.setAttribute('data-is-playing', 'false')
      elem.querySelector('video')?.pause()
    })
  }

  onVideoPlay (video) {
    const card = video.closest('.lumin-shoppable-videos-card')

    this.querySelectorAll('.lumin-shoppable-videos-card').forEach(elem => {
      if (elem.dataset.index !== card.dataset.index) {
        elem.setAttribute('data-is-playing', 'false')
        elem.querySelector('video')?.pause()
      }
    })
    
    if (card.dataset.isPlaying === 'true') {
      card.setAttribute('data-is-playing', 'false')
      video.pause()
    } else {
      card.setAttribute('data-is-playing', 'true')
      video.muted = false
      const playback = video.play()
      playback?.catch(() => card.setAttribute('data-is-playing', 'false'))
    }
  }
}
customElements.define('lumin-shoppable-videos', KsShoppableVideos)


  } catch(e) { console.error(e); }
})();
})();
